// Api
import WebsiteApi from '@/api/WebsiteApi';

const actionTypes = {
    getConfig: 'getConfig',
    getInfo: 'getInfo',

    reset: 'reset',
};

const mutationTypes = {
    SET_CONFIG: 'SET_CONFIG',
    SET_INFO: 'SET_INFO',
};

export default {
    namespaced: true,
    state: {
        /** @type { Object } */
        config: {
            /** @type { Array } */
            faqs: [],
            /** @type { Object } */
            fields: {},
            /** @type { Object } */
            info: {},
        },
        /** @type { Object } */
        info: {},
    },
    getters: {
        /** @returns { Boolean } */
        hasConfig: ( state ) => Object.values( state.config ).length > 0,

        /** @returns { Boolean } */
        hasInfo: ( state ) => Object.values( state.info ).length > 0,

        /** @returns { Number } websiteId */
        id: ( state, getters ) => ( getters.hasInfo ? state.info.id : 0 ),
        locationId: ( state, getters ) => ( getters.hasInfo ? state.info.locationId : 0 ),
        /** @returns { Object } */
        branding: ( state, getters ) => (
            getters.hasConfig
                ? {
                    // primaryColor: state.config.fields.brandPrimaryColor,
                    // secondaryColor: state.config.fields.brandSecondaryColor,
                    primaryColor: '#334b80', /* slingshotBlue at 80% opacity */
                    secondaryColor: '#001e61', /* slingshotBlue */
                    image: state.config.fields.logo,
                    imageMobile: state.config.fields.logoMobile,
                    logoBulterLarge: state.config.fields.logoBulterLarge,
                    logoBulterMedium: state.config.fields.logoBulterMedium,
                    logoBulterMobile: state.config.fields.logoBulterMobile,
                    // imageAltText: state.info.name,
                    imageAltText: 'Butler Logistics',
                    siteName: state.info.name,
                }
                : {
                    primaryColor: '#334b80', /* slingshotBlue at 80% opacity */
                    secondaryColor: '#001e61', /* slingshotBlue */
                    image: '',
                    imageMobile: '',
                    logoBulterLarge: '',
                    logoBulterMedium: '',
                    logoBulterMobile: '',
                    imageAltText: 'Butler Logistics',
                    siteName: '',
                }
        ),
    },
    actions: {
        [ actionTypes.reset ]( { commit } ) {
            commit( mutationTypes.SET_INFO, { info: {} } );
            commit( mutationTypes.SET_CONFIG, {
                config: {
                    faqs: [],
                    fields: {},
                    info: {},
                },
            } );
        },

        /**
         * Get the website config & set config in state
         */
        async [ actionTypes.getConfig ]( context, { jsonFileName } ) {
            try {
                const { data } = await WebsiteApi.getConfig( { jsonFileName } );
                context.commit( mutationTypes.SET_CONFIG, { config: data } );
            } catch ( error ) {
                console.error( 'getConfig error', error );
            }
        },

        /**
         * Get the website info & set info in state, then get the website config
         */
        async [ actionTypes.getInfo ]( context, { websiteId } ) {
            try {
                const { data } = await WebsiteApi.getInfo( { websiteId } );
                context.commit( mutationTypes.SET_INFO, { info: data } );
                await context.dispatch( actionTypes.getConfig, { jsonFileName: data.jsonFileName } );
            } catch ( error ) {
                console.error( 'getInfo error', error );
                throw error;
            }
        },
    },
    mutations: {
        [ mutationTypes.SET_CONFIG ]( state, { config } ) {
            state.config = config;
        },
        [ mutationTypes.SET_INFO ]( state, { info } ) {
            state.info = info;
        },
    },
};
